import { render, staticRenderFns } from "./gift_part_scheme_dialog.vue?vue&type=template&id=18de8a1c"
import script from "./gift_part_scheme_dialog.vue?vue&type=script&lang=js"
export * from "./gift_part_scheme_dialog.vue?vue&type=script&lang=js"
import style0 from "./gift_part_scheme_dialog.vue?vue&type=style&index=0&id=18de8a1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports